import { useState } from "react";
import "./ClassroomTrafficSchool.css";
import heroBanner from "../../assets/images/pages/classroom-traffic-school.jpg";
import ShellCard from "../../components/ShellCard.jsx";
import PackageCard from "../../components/PackageCard";

const ClassroomTrafficSchool = () => {
  const [hoveredCardId, setHoveredCardId] = useState(null);
  const courses = [
    {
      id: 1,
      titleLines: ["4-Hour", "Basic", "Driver Improvement"],
      price: null,
      description:
        "The 4-hour Florida Online Traffic School is the most common course to avoid points on your driver's License.",
      registerUrl:
        "https://classroom.metrotrafficschool.com/create-account/Ng==?_gl=1*mp8p8a*_gcl_au*MTY2MzE2OTE1Ny4xNzYzMzkxMDc3",
      infoUrl: "/4-hour-bdi",
    },
    {
      id: 2,
      titleLines: ["8-Hour", "Intermediate", "Driver Improvement"],
      price: null,
      description:
        "The 8-hour may be taken to avoid points if you already took a 4-hour within the past year or to comply with a judgment.",
      registerUrl: null,
      infoUrl: "/8-hour-idi",
    },
    {
      id: 3,
      titleLines: ["12-Hour", "Advanced", "Driver Improvement"],
      price: null,
      description:
        "This class may be taken in the event of a judgment, Point Suspension or Habitual Traffic Offender.",
      registerUrl: null,
      infoUrl: "/12-hour-adi",
    },
    {
      id: 4,
      titleLines: ["FIRST TIME DRIVER", "(Drug and Alcohol course)"],
      price: null,
      description:
        "This course is required to get your license for the first time. Optional DMV Driver's License Permit Exam and Prep Course.",
      registerUrl:
        "https://classroom.metrotrafficschool.com/create-account/OA==?_gl=1*jul0gm*_gcl_au*MTY2MzE2OTE1Ny4xNzYzMzkxMDc3",
      infoUrl: "/first-time-driver-course",
    },
  ];

  return (
    <>
      <section className="hero-slider-section">
        <div
          className="hero-banner"
          style={{
            backgroundImage: `url(${heroBanner})`,
          }}
        >
          <div className="banner-text-container">
            <div className="banner-heading">
              <h1 className="banner-title">Classroom Course</h1>
              <p className="banner-subheading">
                Please choose from our convenient classroom courses below
              </p>
            </div>
          </div>
        </div>
      </section>

      <main className="online-traffic-school-page">
        <div className="container mt-5">
          <div className="row g-4 mb-5">
            {courses.map((c) => (
              <div className="col-12 col-sm-6 col-lg-3" key={c.id}>
                <PackageCard
                  pkg={{
                    ...c,
                    infoLink: c.registerUrl ? c.infoUrl : null,
                    registerLink: c.registerUrl ? c.registerUrl : c.infoUrl,
                  }}
                  hoveredCardId={hoveredCardId}
                  setHoveredCardId={setHoveredCardId}
                  registerText={c.registerUrl ? "Register" : "More Info"}
                  moreInfoText="More Info"
                />
              </div>
            ))}
          </div>
        </div>
      </main>

      <section className="container">
        <div className="row">
          <div className="col-12">
            <ShellCard>
              <div className="row">
                <div className="col-12">
                  <p className="mb-3 text-white">
                    For students who are interested in an interactive course
                    with a "live" instructor, Live Courses offer a number of
                    benefits.
                  </p>
                  <h3 className="mb-3 fw-bold text-metro-yellow">
                    Becoming a Better Driver is easy with Metro Traffic School's
                    help.
                  </h3>
                  <p className="mb-3 text-white">
                    Metro Traffic school instructors are trained professionals,
                    who are ready to help you understand the course curriculum
                    with an emphasis on defensive driving & safety.
                  </p>
                  <p className="mb-3 text-white">
                    Classes are being offered in Miami-Dade County, Broward
                    County, Palm Beach County.
                  </p>
                  <p className="mb-3 text-white">
                    We have morning, weekday, evening and weekend classes.
                  </p>
                  <p className="mb-3 fw-bold text-white">
                    Please{" "}
                    <a
                      href="/contact-us"
                      className="text-metro-yellow"
                    >
                      contact us
                    </a>{" "}
                    to register for a location and time which is convenient for
                    you
                  </p>
                  <p className="mb-0 text-white">
                    If you live outside the South Florida area, we can offer the{" "}
                    <a
                      href="/online-traffic-school"
                      className="text-metro-yellow fw-bold"
                    >
                      online course
                    </a>
                    .
                  </p>
                </div>
              </div>
            </ShellCard>
          </div>
        </div>
      </section>
      <div className="my-5 container contact-call">
        <p className="mt-3 fw-bold mb-0">
          Call{" "}
          <a href="tel:1-888-41-METRO" className="contact-phone">
            1-888-41-METRO
          </a>{" "}
          for more information.
        </p>
      </div>
    </>
  );
};

export default ClassroomTrafficSchool;
